import script from "./FormScreening.vue?vue&type=script&setup=true&lang=js"
export * from "./FormScreening.vue?vue&type=script&setup=true&lang=js"

import "./FormScreening.vue?vue&type=style&index=0&id=035fb18c&lang=css"

const __exports__ = script;

export default __exports__